import { Loader } from "@logora/debate.progress.loader";
import React, { useState, useEffect, useCallback } from "react";
import { useDataProvider } from "react-admin";
import { ExposeMotifs, TexteBox } from "../../documents";
import styles from "./ActeLegislatifDetails.module.scss";
import { Agenda } from "./Agenda";
import { AmendementList } from "./AmendementList";
import { CommissionMixteParitaire } from "./CommissionMixteParitaire";
import { ConseilConstitutionnel } from "./ConseilConstitutionnel";

export const ActeLegislatifDetails = ({
	acteLegislatif,
	acteDefinition,
	actesLegislatifs,
	exposeMotifsTexte,
}) => {
	const dataProvider = useDataProvider();
	const [isLoading, setIsLoading] = useState(true);
	const [subdivisionRefHash, setSubdivisionRefHash] = useState("");
	const [document, setDocument] = useState(null);

	const handleAmendementButtonClick = (subdivision) => {
		setSubdivisionRefHash(subdivision.hash);
	};

	const fetchDocument = useCallback(
		async (uid) => {
			try {
				const { data } = await dataProvider.getOne("documents", {
					id: uid,
					include: ["alineas", "subdivisions"],
				});

				setDocument(data);
				setIsLoading(false);
			} catch (error) {
				console.error("Error fetching document:", error);
				setIsLoading(false);
			}
		},
		[dataProvider],
	);

	useEffect(() => {
		if (acteLegislatif?.documentRefUid) {
			fetchDocument(acteLegislatif?.documentRefUid);
		} else {
			setDocument(null);
			setIsLoading(false);
		}
	}, [acteLegislatif]);

	return (
		<div className={styles.container}>
			{!isLoading ? (
				<div className={styles.contentContainer}>
					{acteLegislatif.codeActe.startsWith("CC-SAISIE") ? (
						<ConseilConstitutionnel acteLegislatif={acteLegislatif} />
					) : acteLegislatif.codeActe.startsWith("CMP-") ? (
						<CommissionMixteParitaire acteLegislatif={acteLegislatif} />
					) : (
						document && (
							<>
								<div className={styles.top}>
									{acteDefinition?.showExposeMotifs !== false && (
										<ExposeMotifs
											document={document}
											texte={exposeMotifsTexte}
										/>
									)}
									{acteDefinition?.showAgenda !== false && (
										<Agenda
											actesLegislatifs={actesLegislatifs}
											selectedActe={acteLegislatif}
										/>
									)}
								</div>

								<div className={styles.bottom}>
									<TexteBox
										document={document}
										showAmendements={acteDefinition?.showAmendements !== false}
										onAmendementButtonClick={handleAmendementButtonClick}
									/>

									{acteDefinition?.showAmendements !== false && (
										<AmendementList
											document={document}
											subdivisionRefHash={subdivisionRefHash}
										/>
									)}
								</div>
							</>
						)
					)}
				</div>
			) : (
				<Loader />
			)}
		</div>
	);
};
